export enum EProductToUpdate {
  PRODUCT_UPDATED_STATUS = 'PRODUCT_UPDATED_STATUS',
}
export enum ECategoryToUpdate {
  CATEGORY_UPDATED_STATUS = 'CATEGORY_UPDATED_STATUS',
}

export enum EProductUpdatedInfos {
  PRODUCT_UPDATED_INFOS = 'PRODUCT_UPDATED_INFOS',
}

export enum EProductStockUpdated {
  PRODUCT_STOCK_UPDATED = 'PRODUCT_STOCK_UPDATED',
}
